<div class="modal fade" id="confirmationInputModal" #confirmationInputModal tabindex="-1" data-bs-backdrop="static"
    aria-labelledby="confirmationInputModalLabel" aria-hidden="true" style="color: #000000 !important">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex justify-content-between justify-content-center w-100">
                    <h5 class="modal-title"><span [innerHTML]="modalTitle"></span></h5>
                    <i class="fa-solid fa-circle-xmark cursor-pointer" *ngIf="showCloseHeaderButton"
                        (click)="modalClose()"></i>
                </div>

            </div>
            <div class="modal-body">
                <ng-container [ngTemplateOutlet]="fields" [ngTemplateOutletContext]="context"></ng-container>
            </div>
            <div class="modal-footer" *ngIf="showCloseButton || showCancelButton || showSaveButton">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" *ngIf="showCloseButton"
                    (click)="modalClose()">Chiudi</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" *ngIf="showCancelButton"
                    (click)="modalClose()">Annulla</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="modalConfirmClick()"
                    *ngIf="showSaveButton" [disabled]="!confirmBtnEnabled">Conferma</button>
            </div>
        </div>
    </div>
</div>